'use client'

import { ReactNode } from 'react'

export default function ServiceLayoutWrapper({ children }: { children: ReactNode }) {
  return (
    <>
      <div>{children}</div>
      {/* 배너 처리 필요 시 ServiceLayoutWrapper에서 처리 */}
      {/* {banner && banner.length > 0 && <PopupBanner banners={banner} />} */}
    </>
  )
}
